import { render, staticRenderFns } from "./PassengerTransportation.vue?vue&type=template&id=5eb8e686&lang=pug"
import script from "./PassengerTransportation.vue?vue&type=script&lang=js"
export * from "./PassengerTransportation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports